module.exports = __webpack_public_path__ + "img/logo_dichso.ed281379.jpg";